import AppointmentsPage from "./AppointmentsPage";

export default AppointmentsPage;

export * from "./AppointmentsPage";
